module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/ticket-green-94ef390cbe27c682119b6c5bb5c1abbe.svg&quot;;"